var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.keyPair))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.valuePair))]), _vm._v(" "), (_vm.isDownloadableReport) ? _c('td', [_c('button', {
    staticClass: "uk-button uk-button-small",
    attrs: {
      "disabled": _vm.isDownloading
    },
    on: {
      "click": _vm.onDownloadClick
    }
  }, [_vm._v("Download")]), _vm._v(" "), (_vm.isDownloading) ? _c('div', {
    attrs: {
      "uk-spinner": ""
    }
  }) : _vm._e()]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6375afee","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/ImportReports/ImportReportDetail.vue
// module id = 2021
// module chunks = 0